import { ENVIRONMENTS } from "../constants"

/**
 * @group Functions
@summary <blockquote>Validates if a given environment name is a valid environment type.</blockquote>

@param environmentName - The environment name to validate
@returns boolean indicating whether the environment name is valid

@example
```typescript
import { isValidEnvironment } from '@shared/utils';

const isValid = isValidEnvironment('production'); // true
```
 * @internal
 */
export const isValidEnvironment = (environmentName: string): boolean => {
  // Define array of valid environment names
  const validEnvironments: string[] = [
    ENVIRONMENTS.PRODUCTION, 
    ENVIRONMENTS.PREVIEW, 
    ENVIRONMENTS.DEVELOPMENT
  ];
  
  // Check if the provided environment name is in the valid environments array
  const isValid = validEnvironments.includes(environmentName);
  
  return isValid;
}
